<template>
    <div class="kids">
        <page-cover
            v-if="kidsPage.PageCover"
            :img="kidsPage.PageCover.Image?.url ?? ''"
            :title="kidsPage.PageCover.Title"
            :sub-title="kidsPage.PageCover.Subtitle"
        />
        <section v-if="kidsPage.BodyText">
            <div
                class="md:container mx-auto px-4 py-8 lg:px-12 md:py-12 lg:py-24"
            >
                <div class="lg:mx-32">
                    <div class="text-center">
                        <rich-text :text="kidsPage.BodyText.Description" />
                    </div>
                    <div
                        v-if="kidsPage.BodyText.ButtonText"
                        class="text-center mt-8"
                    >
                        <nuxt-link :to="kidsPage.BodyText.ButtonUrl"
                            ><button class="btn btn-primary btn-arrow">
                                {{ kidsPage.BodyText.ButtonText }}
                            </button></nuxt-link
                        >
                    </div>
                </div>
            </div>
        </section>
        <section v-if="kidsPage.RelatedNewsEvents" class="section-bg">
            <div class="px-4 py-8 md:px-12 md:py-12 lg:py-24">
                <h3
                    class="text-2xl md:text-5xl text-primary text-center font-semibold tracking-wide mb-16"
                >
                    {{ kidsPage.RelatedNewsEvents.Title }}
                </h3>
                <masonry-layout
                    :data-items="kidsPage.RelatedNewsEvents.news_events"
                />
            </div>
        </section>
        <section v-if="kidsPage.RelatedStores">
            <div
                class="md:container mx-auto px-4 lg:px-12 py-8 md:py-12 lg:py-24"
            >
                <h3
                    class="text-2xl md:text-5xl text-primary text-center font-semibold tracking-wide mb-16"
                >
                    {{ kidsPage.RelatedStores.Title }}
                </h3>
                <div
                    class="grid lg:grid-cols-4 md:grid-cols-3 grid-cols-2 gap-4 md:gap-6"
                >
                    <storesPageCard
                        v-for="(storeCard, index) in kidsPage.RelatedStores
                            .stores"
                        :key="index"
                        :title="storeCard.Name"
                        :logo-url="storeCard.LogoUrl?.url ?? ''"
                        :nav-to="`/stores/${storeCard.slug}`"
                    />
                </div>
            </div>
        </section>
        <section v-if="kidsPage.RelatedOffers" class="section-bg">
            <div class="px-4 py-8 md:px-12 md:py-12 lg:py-24">
                <h3
                    class="text-2xl md:text-5xl text-primary text-center font-semibold tracking-wide mb-8 md:mb-16"
                >
                    {{ kidsPage.RelatedOffers.Title }}
                </h3>
                <div
                    class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-12"
                >
                    <OfferPageCard
                        v-for="(offer, index) in kidsPage.RelatedOffers.offers"
                        :key="index"
                        :title="offer.Title"
                        :image="offer.Poster?.url ?? ''"
                        :expiry="checkExpiry(offer.ExpiresOn)"
                        :nav-to="`/offers/${offer.Slug}`"
                    />
                </div>
            </div>
        </section>
    </div>
</template>

<script setup>
import dayjs from 'dayjs';
const config = useRuntimeConfig();
const { data: kidsPage } = await useFetch(config.public.baseURl + '/kids');
function checkExpiry(exp) {
    return exp
        ? dayjs(dayjs(exp)).diff(new Date(), 'day') < 10
            ? `Expires on ${dayjs(exp).format('DD/MM/YYYY')}`
            : 'On Going'
        : '';
}
useHead({
    title: 'Kids',
});
</script>

<style lang="scss" scoped>
.kids {
}
</style>
